export class Step3 {
    constructor() {}

    getclassificationorganisme = 'form.dive_at.getclassificationorganisme';
    getspan2 = 'form.dive_at.getspan2';
    getacheteurpublic = 'form.dive_at.getacheteurpublic';
    getpaysnonfrance = 'form.dive_at.getpaysnonfrance';
    geturlprofilacheteur = 'form.dive_at.geturlprofilacheteur';

}
